// @flow
import * as React from 'react';

import RolePickerContainer from './RolePickerContainer';
import RolePickerForm from './RolePickerForm';

type Props = {
  onSelect: (role: string) => void,
};

class RolePicker extends React.Component<Props, *> {
  render() {
    return (
      <RolePickerContainer>
        {props => <RolePickerForm {...props} onSelect={this.props.onSelect} />}
      </RolePickerContainer>
    );
  }
}

export default RolePicker;
